const styles = () => ({
    cardImageRow: {
        height: '192px'
    },
    cardAvatar: {
        display: 'inline-block',
        padding: '10px',
        height: '192px',
        width: '100%'
    },
    hidden: { display: 'none' }
});

export default styles;